import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import i18next from 'i18next'
import classnames from 'classnames'

import listingStyles from './styles/listing.scss'

export default class UnitListRow extends PureComponent {
  handleSelect = () => this.props.onSelect(this.props.unit.uuid)

  handleDelete = event => {
    event.preventDefault()

    this.props.onDelete(this.props.unit.uuid)
  }

  render() {
    const { unit: { uuid, name, description, wopi360Count }, isSelected, isDeleted } = this.props

    return (
      <tr
        className={classnames({
          [listingStyles.deleted]: isDeleted
        })}
      >
        {!isDeleted && (
          <td className={listingStyles.select} style={{ width: 80 }} onClick={this.handleSelect}>
            <input type="checkbox" checked={isSelected} />
          </td>
        )}
        {isDeleted && <td className={listingStyles.select} style={{ width: 80 }} />}

        <td>
          <Link to={`/units/${uuid}`}>{name}</Link>
          <small>{description}</small>
        </td>

        {!isDeleted && (
          <td>
            <Link to={`/units/${uuid}`}>
              {wopi360Count} {i18next.t('pcs')}
            </Link>
          </td>
        )}
        {isDeleted && <td>-</td>}

        {!isDeleted && (
          <td>
            <a href="#" onClick={this.handleDelete}>
              {i18next.t('delete')}
            </a>
          </td>
        )}

        {isDeleted && (
          <td>
            <span>{i18next.t('deleted')}</span>
          </td>
        )}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitListRow.js